import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";

import DialogBackdrop from "./DialogBackdrop";

const PaymentProfileConfirmationModel = ({
  state,
  setState,
  title,
  desc,
  isUpdated,
  setIsUpdated,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Transition appear show={state} as={Fragment}>
        <Dialog
          className="fixed inset-0 z-10 overflow-y-auto"
          as="div"
          open={state}
          onClose={() => {
            setState(false);
            setIsUpdated(!isUpdated);
          }}
        >
          <DialogBackdrop />

          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>
            {/* This element is to trick the browser into centering the modal contents. */}

            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-2xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <Dialog.Title
                  as="h2"
                  className="dialog_label2 font-body text-xl font-bold text-left"
                >
                  {title}
                  <button
                    className="ui-default-dialog-close"
                    onClick={() => {
                      setState(false);
                      setIsUpdated(!isUpdated);
                    }}
                  >
                    <svg
                      className="ui-icon h-3.5 w-3.5"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-close"></use>
                    </svg>
                  </button>
                </Dialog.Title>

                <Dialog.Description className="mx-auto lg:w-4/5">
                  {desc}
                </Dialog.Description>

                <div className="block text-right mt-6">
                  <button
                    className="ui-btn-primary min-w-[140px]  mt-4"
                    aria-label="Go to my policies now"
                    onClick={() => {
                      setState(false);
                      setIsUpdated(!isUpdated);
                    }}
                  >
                    {t("CustomerManagePayment-manage-payment-card-close")}
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default PaymentProfileConfirmationModel;
